/* eslint-disable @typescript-eslint/camelcase */
import * as Yup from 'yup';
import i18n from 'i18n';
import { regexExp } from 'utils/helpers';

export default Yup.object().shape({
  primary_main_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  primary_contrast_text_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  background_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  image_login_background_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  message_text_color: Yup.string()
    .notOneOf(
      [Yup.ref('primary_color'), null],
      i18n.t('PARTNER_PAGE.NOT_EQUAL_COLOR_MAIN_KEY')
    )
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  text_hover_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .notOneOf(
      [Yup.ref('primary_color'), null],
      i18n.t('PARTNER_PAGE.NOT_EQUAL_COLOR_MAIN_KEY')
    )
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  secondary_main_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  logo_background_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  details_login_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  app_color: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, i18n.t('NOT_HEX_FIELD_KEY')),
  is_full_domain: Yup.boolean(),
  domain: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .when('is_full_domain', {
      is: true,
      then: schema =>
        schema
          .max(
            253,
            i18n.t('MAX_LENGTH_KEY', {
              value: 253,
            })
          )
          .matches(regexExp.domain, i18n.t('DOMAIN_REGEX_RULE_KEY')),
      otherwise: schema =>
        schema
          .max(
            40,
            i18n.t('MAX_LENGTH_KEY', {
              value: 40,
            })
          )
          .matches(regexExp.subdomain, i18n.t('SUBDOMAIN_REGEX_RULE_KEY')),
    }),

  header_login_text_pt_br: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  description_login_text_pt_br: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  header_mfa_text_pt_br: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  description_mfa_text_pt_br: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  header_login_text_es: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  description_login_text_es: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  header_mfa_text_es: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  description_mfa_text_es: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  header_login_text_en: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  description_login_text_en: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  header_mfa_text_en: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
  description_mfa_text_en: Yup.string().max(
    255,
    i18n.t('MAX_LENGTH_KEY', {
      value: 255,
    })
  ),
});
